import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import Spinner from 'srcReact/components/common2/Spinner'
import { messengerActions } from 'srcReact/MessengerPage'
import styles from './styles.module.scss'

const ResumeConversation = ({ closeModal }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    messenger: { openedConversation, loading },
    login: { user },
    common: { isMobile }
  } = useSelector((state) => state)
  const [markResumed, setMarkResumed] = useState(false)

  useEffect(() => {
    if (!loading && markResumed) {
      close()
      if (isMobile) {
        dispatch(messengerActions.showMainContent(false))
        dispatch(messengerActions.showSidebar(true))
      }
    }
  }, [loading])

  const close = () => {
    closeModal()
  }
  const resumeConversation = () => {
    if (openedConversation.conversation.id > 0) {
      setMarkResumed(true)
      dispatch(messengerActions.resumeConversation(openedConversation.conversation.id))
    }
  }

  return (
    <React.Fragment>
      <h1 className={styles.title}>{t('messenger.header.resumeConversationTitle')}</h1>
      <div className={styles.buttonWrapper}>
        <Button size='large' text={t('messenger.btnCancel')} style='tertiary' handleClick={close} />
        <Button
          size='large'
          text={loading ? <Spinner customCss={styles.spinner} isWhite={true} /> : t('messenger.btnDoIt')}
          handleClick={resumeConversation}
        />
      </div>
    </React.Fragment>
  )
}

export default ResumeConversation
